<template>
  <div class="setAttachment">
    <a-drawer
      title="搜索资源库资源"
      :width="600"
      @close="onClose"
      :visible="showResource"
      :bodyStyle="{ paddingBottom: '80px' }"
    >
      <div style="marginBottom: 20px;">
        <a-input-search v-model="resourceName" placeholder="请输入资源名称" enter-button @search="onSearch" />
      </div>
      <a-table :columns="columns" :dataSource="resourceList" rowKey="id" :pagination="false">
        <div slot="operation" slot-scope="operation">
          <a @click="chooseResource(operation)">选择</a>
        </div>
      </a-table>
      <div class="fenye">
        <a-pagination
          size="small"
          :pageSizeOptions="pageSizeOptions"
          :total="total"
          showSizeChanger
          showQuickJumper
          :pageSize="pageSize"
          v-model="current"
          @showSizeChange="onShowSizeChange"
          @change="onChange"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
      </div>
    </a-drawer>
  </div>
</template>

<script>
const columns = [
  {
    title: '资源名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '操作',
    key: 'operation',
    width: 80,
    scopedSlots: { customRender: 'operation' }
  }
];

export default {
  data(){
    return {
      columns,
      showResource: false,
      resourceList: [],
      resourceName: '',
      pageSizeOptions: ['10', '20', '30', '40'],
      current: 1,
      pageSize: 10,
      total: 0
    }
  },
  created () {
    this.getResourceLibrary();
  },
  methods: {
    showModal(){
      this.showResource = true;
    },
    onSearch(value) {
      this.resourceName = value;
      this.getResourceLibrary();
    },
    onChange(pageNumber) {
      this.current = pageNumber;
      this.getResourceLibrary();
    },
    onShowSizeChange(current, pageSize) {
      this.current = 1;
      this.pageSize = pageSize;
      this.getResourceLibrary();
    },
    getResourceLibrary(){
      let url = this.apis.courseDataUpload.getResourceLibrary;
      this.http.post(url, {
        where: {
          name_like: this.resourceName,
          status_eq: '3'
        },
        currentPage: this.current,
        pageSize: this.pageSize
      })
      .then((res)=>{
        console.log(res);
        this.resourceList = res.data;
        this.total = res.pageInfo.totalCount;
      }).catch((err)=> {
        console.log(err);
      });
    },
    chooseResource(item){
      console.log(item);
    },
    onClose(){
      this.showResource = false;
    }
  }
}
</script>

<style lang="less" scoped>
.fenye{
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>